export default __webpack_public_path__ + "static/favicon-b3c9ddc25a73925141dc475ffeb05572.ico";